import styled from 'styled-components';

export default styled.div`

.features-container {
  background: #F5F5F7 !important;
  max-width: 1280px;
  padding: 0;
  margin: 30px auto;
  margin-bottom: 0;

  ${props => props.theme.media.md} {
    background: white;
    margin: 30px auto;
  }

  h2 {
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 30px;
    ${props => props.theme.media.md} {
      font-size: 40px;
      margin-bottom: 20px;
    }
  }

  .subtitle {
    font-family: Inter;
    font-size: 16px;
    line-height: 24px;
    max-width: 325px;
    width: 100%;
    margin: auto;
    text-align: center;
    font-weight: 350;
    margin-bottom: 32px;

    ${props => props.theme.media.lg} {
      text-align: left;
      max-width: 555px;
      margin-bottom: 55px;
    }
  }

  .features-list {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
  }

  .feature {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 0 15px;
    width: 100%;

    ${props => props.theme.media.md} {
      margin-bottom: 30px;
      width: 33%;
      padding: 0 30px;
    }

    .icon {
      align-items: center;
      background-color: #FE6600;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      width: 105px;
      height: 105px;
      min-height: 105px;
      min-width: 105px;
      ${props => props.theme.media.md} {
        min-height: 103px;
        min-width: 103px;
        width: 103px;
        height: 103px;
      }
    }
    
    .icon-wrapper {
      position: relative;
      width: 100%;
      height: 100%;

      & img {
        width: 100%;
        height: 100%;
      }
    }
    
    .bordered-container {
      width: 100%;
      position: relative;
      padding-bottom: 25px;

      :before {
        content: '';
        position: absolute;
        top: -140px;
        right: -27px;
        width: 1px;
        height: 300px;
        background: #e5e5e5;
      }
    }

    &:last-of-type .bordered-container :before {
      display: none;
    }

    .content {
      position: relative;
      text-align: center;
      width: 100%;
      margin: auto;

      h3 {
        font-size: 20px;
        color: #3F5261;
        font-weight: 500;
        margin: 0.5em auto;
        text-align: center;
        line-height: 1.3;
        max-width: 350px;
        ${props => props.theme.media.md} {
          font-size: 23px;
        }
      }

      p {
        font-size: 15px;
        margin-bottom: 0;
        max-width: 326px;
        text-align: center;
        margin: auto;
        font-weight: 350;

        ${props => props.theme.media.md} {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 1rem;
          font-weight: 350;
          max-width: 325px;
          text-align: left;
        }
      }

      a {
        display: inline-block;
        align-self: center;
        background: #60B9A9;
        border-radius: 2.5rem;
        color: #fff;
        margin-top: 1rem;
        padding: 0.25rem .75rem;
        text-decoration: none;
        text-align: center;
        font-weight: 300;
        font-size: 14px;

        :hover {
          background: #89D3C6;
        }

        ${props => props.theme.media.md} {
          align-self: flex-start;
          margin-top: 0rem;
          min-width: 13rem;
          text-align: center;
        }
      }
    }

    &:first-of-type .content h3 {
      max-width: 350px;
    }
  }

  .need:first-of-type svg {
    margin-right: 10px;
  }
}

&.income-taxes {
  .subtitle {
    ${props => props.theme.media.lg} {
      max-width: 641px;
      line-height: 24px;
      font-size: 16px;
    }
  }

  .feature {
    h3 {
      font-size: 26px !important;
    }
  }

  .feature:first-child {
    .content {
      h3 {
        width: 236px;
        margin: auto;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

    & .icon-wrapper {
      width: 44px;
      height: 62px;
    }
  }

  .feature:nth-child(2) {
    p {
      ${props => props.theme.media.lg} {
        margin-top: 40px !important;
      }
    }
  }

  .feature:nth-child(3) {
    p {
      ${props => props.theme.media.lg} {
        margin-top: 43px !important;
      }
    }
  }
}

&.tax-smart {
  & .feature:first-child {
    & .icon-wrapper {
      width: 57px;
      height: 56px;
    }
  }
}
//////
   .tooltip-inline {
    display: inline-block;
    font-size: 18px;
    height: 18px;
    position: static;
    ${props => props.theme.media.sm} {
      position: relative;
    }

    width: 18px;
  
    left: 3px;
    right: 2px;
    .tooltip-i{
      cursor: pointer;
    }
    .tooltip-text-inline {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      background-color: #ECE5D8;
      border-radius: 7px;
      box-shadow: 0px 2px 4px rgba(2, 36, 30, 0.15);
      color: ${props => props.theme.textColor};
      width: 100%;
      max-width: 400px;
      padding: 1rem 1rem;
      position: absolute;
      right: 0;
      font-family: Inter;
      margin-top: 5px;
      ${props => props.theme.media.sm} {
        width: 280px;
        top: 30px;
        margin-top: 0;
        right: auto;
      }
      ${props => props.theme.media.lg} {
        width: 360px;
      }
      visibility: hidden;
      z-index: 1;
      &.cc{
        right: 0;
      }
    }

    &:hover {
      .tooltip-text-inline {
        visibility: visible;
      }
    }
  }

`;
